import { Credentials } from "./constants"

export type TripSeasons = {
   start: string;
   end: string;
};

interface TripResult {
   trip?: any;
}

interface SearchTripsResult {
   trips?: any[];
   meta?: {
      current_page: number;
      next_page: number;
      prev_page: number;
      total_pages: number;
      total_count: number;
   };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const searchTrips = async (query: { [key: string]: any }, authToken: string) => {

   // support special case for search by multiple ids
   // as BMS search does not support this
   if (query.ids) {
      const ids = (query.ids as string).split(',');
      return getTrips(ids, authToken);
   }

   // eslint-disable-next-line @typescript-eslint/no-explicit-any
   const searchQuery: { [key: string]: any; page: number } = { ...query, page: 0 };
   const tripList = [];

   // eslint-disable-next-line no-constant-condition
   while (true) {
      searchQuery.page += 1;
      const searchQueryString = new URLSearchParams(searchQuery)
      const searchUrl = `${Credentials.endpoint}/v1/trips/search/?${searchQueryString.toString()}`;

      console.log('bmsService', 'searchTrips', searchUrl);

      const response = await fetch(searchUrl, {
         method: 'GET',
         headers: {
            Authorization: `Bearer ${authToken}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
         },
      });

      const result: SearchTripsResult = await response.json();

      if (!result || !result.trips || result.trips.length === 0) {
         break;
      }

      tripList.push(...result.trips);

      console.log('bmsService', 'found trips', tripList.length);
   }

   return tripList;
};

export const getTrips = async (ids: string[], authToken) => {
   const trips = await Promise.all(
      ids.map(async (t) => {
         try {
            const result = await getTrip(t, authToken);
            return result.trip || null;
         } catch (error: any) {
            console.log('bmsService', 'getTrip', error.message);
            return null;
         }
      })
   );

   return trips.filter((t) => !!t).map((t) => t);
};

export const getTrip = async (id: string, authToken?: string) => {
   const getUrl = `${Credentials.endpoint}/v1/trips/${id}`;

   console.log('bmsService', 'getTrip', getUrl);

   const response = await fetch(getUrl, {
      method: 'GET',
      headers: {
         Authorization: `Bearer ${authToken}`,
         Accept: 'application/json',
         'Content-Type': 'application/json',
      },
   });

   const data: TripResult = await response.json()

   return data;
};

export const signIn = async () => {
   const response = await fetch(`${Credentials.endpoint}/users/sign_in`, {
      method: 'POST',
      body: JSON.stringify({
         user: {
            username: Credentials.user,
            password: Credentials.password,
         },
      }),
      headers: {
         'Content-Type': 'application/json',
      },
   });

   const data: { auth_token: string; } = await response.json()

   return data
}

export const getTripDetails = async (id: string, authToken?: string) => {

   const getUrl = `${Credentials.endpoint}/v1/trips/${id}/detail`;

   console.log('bmsService', 'getTripDetail', getUrl);

   const response = await fetch(getUrl, {
      method: 'GET',
      headers: {
         Authorization: `Bearer ${authToken}`,
         Accept: 'application/json',
         'Content-Type': 'application/json',
      },
   });
   const { trip } = await response.json();

   const seasons = parseSeasons(trip.seasons);

   const metadata = {
      seasons,
   };

   const tripDetails = {
      ...trip,
      metadata,
   };

   return tripDetails;
};

export const parseSeasons = (original: string[]): TripSeasons[] => {
   const result = original?.map((season) => {
      const value = season.split('..');
      return {
         start: value[0],
         end: value[1],
      };
   });

   return result;
};